import { Pipe, PipeTransform } from '@angular/core';
import Utils from '../util/util';

@Pipe({ name: 'commonBlockState' })
export class CommonBlockStatePipe implements PipeTransform {
  transform(input: string): string {
    return Utils.commonBlockResultType(input);
  }
}
